import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import html2canvas from 'html2canvas';
import PDF from 'jspdf';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPdfmake from 'html-to-pdfmake';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import {
    getProfitData, handleLoader
} from '../../../../redux/actions/ProfitAction';
import { findMonthsBetweenDates } from '../../../../utils/helpers';
import {
    months, tableHeaderDataProfit, tableHeaderDataProfitForShopify,
    vendorNameMapping, tableHeaderDataProfitWholesale
} from '../../helper';
import ProfitBar from './ProfitBar';
import ProfitTable from './ProfitTable';

const tableHeader = {
    amazon: tableHeaderDataProfit,
    shopify: tableHeaderDataProfitForShopify,
    wholesale: tableHeaderDataProfitWholesale
}

const Profit = ({ dispatch, vendor }) => {
    const location = useLocation();
    const [currentYear, currentMonth] = moment().format('YYYY-MMM').split('-');
    const [prevYear, prevMonth] = moment().subtract(6, 'months').format('YYYY-MMM').split('-');

    const { isLoading, profitData, salesChannelFilterData } = useSelector(
        ({ profitReducer, marketPlaceReducer }) =>
        ({
            salesChannelFilterData: marketPlaceReducer.salesChannel,
            profitData: profitReducer?.[vendor]?.profitData,
            isLoading: profitReducer?.[vendor]?.isLoading,
        })
    );

    const [profitDataToShow, setProfitDataToShow] = useState([]);
    const [filterData, setFilterData] = useState({});
    const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth });
    const [month1, setMonth1] = useState({ year: prevYear, month: prevMonth })
    const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
    const [tempMonth1, setTempMonth1] = useState({ year: prevYear, month: prevMonth })

    const yearOptions = [];
    for (let year = 2016; year <= currentYear; year += 1) {
        yearOptions.push({ label: year, value: year })
    }

    const monthOptions = months.map(item => ({ label: item, value: item }));

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    const callApi = ({ tempMon1, tempMon2 }) => {
        const data = {
            from: tempMon1?.year, to: tempMon2?.year,
            fromMonth: moment().month(tempMon1?.month).format('M'),
            toMonth: moment().month(tempMon2?.month).format('M'),
            vendor
        }
        dispatch(handleLoader(true, vendor))
        dispatch(getProfitData(data));
    }

    const handleApplyDate = () => {
        const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
        const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

        const monthsBetween = findMonthsBetweenDates(startDate, endDate);
        if (monthsBetween?.length > 0) {
            setMonth1(tempMonth1);
            setMonth2(tempMonth2);
            callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        } else {
            Notification.newInstance({}, (notification) => {
                notification.notice({
                    content: 'Please select minimum two months'
                });
            });
        }
    }

    const handleYearMonthChange = ({ isFrom, field, value }) => {
        if (isFrom) {
            setTempMonth1({ ...tempMonth1, [field]: value?.value });
        } else {
            setTempMonth2({ ...tempMonth2, [field]: value?.value });
        }
    }

    // Generate PDF //

    const printDocument = () => {
        const doc = new PDF();        
        const pdfDoc = document.getElementById('divToPrint');
        const html = htmlToPdfmake(pdfDoc.innerHTML);
        const documentDef = { content: html };
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.createPdf(documentDef).open();     
    }

    const divToPDF = (e) => {
        const but = e.target;
        but.style.display = "none";
       // const input = window.document.getElementsByClassName("dvPdf")[0];
       const input = document.getElementById('divToPrint');
      
        html2canvas(input).then((canvas) => {
          const img = canvas.toDataURL('image/png');
          console.log(img)
          const pdf = new PDF("landscape", "pt", "A4");
          const imgProps = pdf.getImageProperties(img);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();
         // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(
            img,
            "png",
            0,
            0,
            pdfWidth,
            pdfHeight
            // input.offsetLeft,
            // input.offsetTop,
            // input.offsetWidth,
            // input.offsetHeight
          );
        //  pdf.autoTable({html: '#divToPrint'})
        pdf.setFont('verdana', 'normal');
          pdf.save("Profit_Report.pdf");
          but.style.display = "block";
        });
      };

      const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    const btnPdf = document.getElementById('btnExportPDF');
    btnPdf.style.display = 'none';
    Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'PDF loading......',
          duration: 5,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 10
        });
      });
    const element = container.current || document.body;
    savePDF(element, {
        repeatHeaders: true,
      paperSize: "auto",
      Header: "test",
      margin: 40,
      fileName: `Profit Report ${new Date().getFullYear()}`,
    })
    btnPdf.style.display = "block";  
  }


    // eslint-disable-next-line react/prop-types
    const RenderYearAndMonth = ({ isFrom }) => (
        <Col sm="4" className="">
            <Row className="align-items-center">
                <Col sm="5" className="">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Year</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                                    : { value: tempMonth2?.year, label: tempMonth2?.year }}
                                options={yearOptions}
                                clearable={false}
                                placeholder="Select Year"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'from' : 'to'}
                            />
                        </div>

                    </div>
                </Col>
                <Col sm="5" className="">
                    <div className="form__form-group mb-0">
                        <span className="form__form-group-label">Month</span>
                        <div className="form__form-group-field">
                            <Select
                                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                                    : { value: tempMonth2?.month, label: tempMonth2?.month }}
                                options={monthOptions}
                                clearable={false}
                                placeholder="Select Month"
                                className="select_filter-110"
                                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                                classNamePrefix="react-select"
                                name={isFrom ? 'fromMonth' : 'toMonth'}
                            />
                        </div>
                    </div>
                </Col>
                {isFrom ? <Col sm="2">~</Col> : null}
            </Row>

        </Col>
    );

    useEffect(() => {
        dispatch(handleLoader(true));
        callApi({ tempMon1: tempMonth1, tempMon2: tempMonth2 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setProfitDataToShow(profitData?.modal?.data || []);
    }, [profitData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    const profitDataToShowForDatesSelected = profitDataToShow?.filter(item =>
        filterBasedOnFilter(item));

        
    return (
        <Container className="dashboard">
            <Row className="sales-breakdown">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">{vendorNameMapping[vendor]} Profit </h5>
                            </div>
                            <Row className="align-items-center">
                                <RenderYearAndMonth isFrom />
                                <RenderYearAndMonth />
                                <Col sm="2" style={{ top: '10px' }}>
                                    <button className="btn btn-sm btn-primary apply-date-button"
                                        type="button" onClick={handleApplyDate}>
                                        Apply</button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div  id="divToPrint" ref={container}>
            <Row className="show-sales-region">           
                <Col md="12">   
                    <Card>
                        <CardBody>
                            <div className="top-location" style={{ minHeight: '400' }}>
                                <div className="card__title row align-items-center">
                                    <h5 className="bold-text col-md-10">Net Profit</h5>
                                    <div className="text-right col-md-2">
                                    <button className="btn btn-primary"  type="button" id='btnExportPDF'
                                    onClick={exportToPDF} disabled={isLoading}>Export To PDF</button>
                                        </div>
                                </div>
                                <div >
                                    {isLoading ? <div style={{ minHeight: '200px' }}
                                        className="row align-items-center justify-content-center">
                                        <SmallLoader loading={isLoading} />
                                    </div>
                                        : <ProfitBar month1={month1} month2={month2} vendor={vendor}
                                            height={400} data={profitDataToShowForDatesSelected || []} />}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col sm="12">
                    <Card>
                        <CardBody>
                            <div className="top-location" style={{ minHeight: '400' }}>
                                <div className="card__title row align-items-center">
                                    <h5 className="bold-text col-md-4">Net Profit</h5>
                                </div>
                                <div >
                                    {isLoading ? <div style={{ minHeight: '200px' }}
                                        className="row align-items-center justify-content-center">
                                        <SmallLoader loading={isLoading} />
                                    </div>
                                        : <ProfitTable 
                                            fileName={`${vendorNameMapping[vendor]} Profit Report`}
                                            tableHeaderData={tableHeader[vendor]}
                                            data={profitDataToShowForDatesSelected}
                                            vendor={vendor} />}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            </div>
        </Container>
    );
};

Profit.propTypes = {
    dispatch: PropTypes.func.isRequired,
    vendor: PropTypes.number.isRequired
};

export default connect(state => ({
    rtl: state.rtl,
}))(Profit);
